import axios from 'axios';

import config from '@/config/config';
import { headers } from './auth.headers';
import { formatQueryString } from '@/helpers/query-string';
import { ICity } from '@/domain/city.model';
import { IPaginateVueTable } from '@/interfaces/IPaginateVueTable';

const url_api_base = config.url_api_base;

export const insert = (data: ICity): Promise<ICity> => {
  return axios.post(`${url_api_base}/city`, data, headers());
};

export const update = (data: ICity): Promise<ICity> => {
  return axios.patch(`${url_api_base}/city/${data.id}`, data, headers());
};

export const get = (id: string): Promise<ICity> => {
  const url = `${url_api_base}/city/${id}`;

  return axios.get(url, headers()).then((res) => res?.data);
};

export const list = (
  offset?: number,
  limit?: number,
  order?: string,
  sort?: string,
  filter?: string,
): Promise<IPaginateVueTable<ICity>> => {
  const query = formatQueryString(offset, limit, order, sort, filter);
  const url = `${url_api_base}/city${query}`;

  return axios.get(url, headers()).then((res) => res?.data);
};

export const listActive = (): Promise<ICity[]> => {
  const url = `${url_api_base}/city/list-active`;

  return axios.get(url, headers()).then((res) => res?.data);
};
